export default "__VITE_ASSET__DbdAKtQm__"